import { useTranslation } from 'react-i18next';
import { ConfigProvider } from 'antd';
import { useDevice } from '@/hooks';
import { useDormitoryReport } from '@/hooks/app';
import { PageContainer, DeviceWrapper } from '@/components';
import LeaveReportDesktop from './LeaveReportDesktop';
import LeaveReportMobile from './LeaveReportMobile';

function DormitoryLeaveReport() {

  const [t] = useTranslation(['common', 'dormitory']);
  const { isDesktop } = useDevice();
  const report = useDormitoryReport();

  return (
    <PageContainer displayFlex title={t('common:features.dormitory-leave-registeration')}>
      <ConfigProvider componentSize={isDesktop() ? 'large' : 'middle'}>
        <DeviceWrapper show={['desktop']}>
          <LeaveReportDesktop {...report} />
        </DeviceWrapper>
        <DeviceWrapper show={['mobile']}>
          <LeaveReportMobile {...report} />
        </DeviceWrapper>
      </ConfigProvider>
    </PageContainer>
  );
}

export default DormitoryLeaveReport;
